import ChevronLeftIcon from 'images/icons/ChevronLeft.svg';
import ChevronRightIcon from 'images/icons/ChevronRight.svg';

import { Icon } from 'components/Icon';

import styles from '../../ImageSlider.module.scss';

interface Action {
  disabled?: boolean;
  onAction: () => void;
}

interface ControlsProps {
  prevAction: Action;
  nextAction: Action;
}

export function Controls({ prevAction, nextAction }: ControlsProps) {
  return (
    <div className={styles.Controls}>
      <button
        className={styles.Control}
        disabled={prevAction.disabled}
        aria-label="Prev"
        onClick={prevAction.onAction}
      >
        <Icon source={ChevronLeftIcon} color="inherit" />
      </button>
      <button
        className={styles.Control}
        disabled={nextAction.disabled}
        aria-label="Next"
        onClick={nextAction.onAction}
      >
        <Icon source={ChevronRightIcon} color="inherit" />
      </button>
    </div>
  );
}
